import { app } from './default/app';
import { thread } from './default/thread';

export const mock = {
  app,
  thread,
};
